export default __webpack_public_path__ + "navigation-overview-view-hierarchy-1200-9d3ff2cf218dc99afc01247eda1f93c1.png";